import { render, staticRenderFns } from "./PreviewForm15.vue?vue&type=template&id=1b005024&scoped=true"
import script from "./PreviewForm15.vue?vue&type=script&lang=ts"
export * from "./PreviewForm15.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b005024",
  null
  
)

export default component.exports